import { render, staticRenderFns } from "./UIAudioBtn.vue?vue&type=template&id=34e7edb8&scoped=true&"
import script from "./UIAudioBtn.vue?vue&type=script&lang=ts&"
export * from "./UIAudioBtn.vue?vue&type=script&lang=ts&"
import style0 from "./UIAudioBtn.vue?vue&type=style&index=0&id=34e7edb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e7edb8",
  null
  
)

export default component.exports